import type {
  BackupPolicySecurityConfig,
  Condition,
  Configuration,
} from '@repo/api-gw-sdk';
import {
  GetSecurityPlanApi,
  SaveSecurityPlanApi,
  SecurityScansApi,
  UpdateSecurityScanPoliciesConfigApi,
} from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

const baseUrl = '/security';

export const security = (
  httpClient: HttpClient,
  config: Configuration,
  currentProjectId: string
) => {
  const securityScansApi = new SecurityScansApi(config);
  const getSecurityPlanApi = new GetSecurityPlanApi(config);
  const saveSecurityPlanApi = new SaveSecurityPlanApi(config);
  const updateSecurityScanPoliciesConfigApi =
    new UpdateSecurityScanPoliciesConfigApi(config);

  return {
    getScansSummary: (resourceId: string) =>
      httpClient.execute(
        [baseUrl, 'getScansSummary', resourceId, currentProjectId],
        () =>
          securityScansApi.getSecurityScansSummary(resourceId, currentProjectId)
      ),
    countInfectedResources: () =>
      httpClient.execute([baseUrl, 'count', currentProjectId], () =>
        securityScansApi.countInfectedResources(currentProjectId)
      ),
    excludeResource: (resourceId: string) =>
      securityScansApi.updateResourceSecurityScansExclusion(
        currentProjectId,
        resourceId,
        {
          excluded: true,
        }
      ),
    cancelResourceExclusion: (resourceId: string) =>
      securityScansApi.updateResourceSecurityScansExclusion(
        currentProjectId,
        resourceId,
        {
          excluded: false,
        }
      ),
    updatePolicies: (policies: BackupPolicySecurityConfig[]) =>
      updateSecurityScanPoliciesConfigApi.updateSecurityScanPoliciesConfig(
        currentProjectId,
        { policiesConfig: policies }
      ),
    getSecurityPlan: () =>
      httpClient.execute([baseUrl, 'getSecurityPlan', currentProjectId], () =>
        getSecurityPlanApi.getSecurityPlan(currentProjectId)
      ),
    saveSecurityPlan: (
      condition: Condition | undefined,
      include: string[] = [],
      exclude: string[] = []
    ) =>
      saveSecurityPlanApi.saveSecurityPlan(currentProjectId, {
        condition,
        include,
        exclude,
      }),
  };
};
